import { useMemo } from "react";
export function useMergeRefs(ref1, ref2) {
  return useMemo(function () {
    return mergeRefs(ref1, ref2);
  }, [ref1, ref2]);
}
export function mergeRefs(ref1, ref2) {
  return function (v) {
    setRef(ref1, v);
    setRef(ref2, v);
  };
}

function setRef(ref, v) {
  if (typeof ref === "function") {
    ref(v);
  } else if (ref) {
    ref.current = v;
  }
}
//# sourceMappingURL=useMergeRefs.js.map